import { SingleDatePicker } from "@/components/SingleDatePicker";
import { TimePicker } from "@/components/TimePicker";
import { FormField, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { ElementsContainer, TwoColumnElementsContainer } from "@repo/ui";

export const CustomRangePicker = ({
  selectedOption,
  setSelectedOption,
  maxEndDate,
}: {
  selectedOption: any;
  setSelectedOption: (opt: any) => void;
  maxEndDate?: Date;
}) => {
  const startDate = selectedOption.start;
  const endDate = selectedOption.end;
  const startTime = selectedOption.startTime ?? startDate;
  const endTime = selectedOption.endTime ?? endDate;

  const handleStartDateChange = (date: Date) =>
    setSelectedOption({ ...selectedOption, start: date });
  const handleStartTimeChange = (time: Date) =>
    setSelectedOption({ ...selectedOption, startTime: time });
  const handleEndDateChange = (date: Date) =>
    setSelectedOption({ ...selectedOption, end: date });
  const handleEndTimeChange = (time: Date) =>
    setSelectedOption({ ...selectedOption, endTime: time });

  return (
    <ElementsContainer>
      <Text textStyle="Heading.XS">{t("label.from")}</Text>
      <TwoColumnElementsContainer>
        <FormField
          shouldValidate={!startDate}
          valid={Boolean(startDate)}
          validation={{
            msg: t("prompt.invalid_date"),
            id: "error",
            type: "error",
          }}
        >
          <SingleDatePicker
            id="start-date"
            label={t("label.date")}
            value={startDate}
            onChange={handleStartDateChange}
          />
        </FormField>
        <TimePicker
          id="start-time"
          label={t("label.time")}
          value={startTime}
          onChange={handleStartTimeChange}
        />
      </TwoColumnElementsContainer>

      <Text textStyle="Heading.XS">{t("label.to")}</Text>
      <TwoColumnElementsContainer>
        <FormField
          shouldValidate={!endDate}
          valid={Boolean(endDate)}
          validation={{
            msg: t("prompt.invalid_date"),
            id: "error",
            type: "error",
          }}
        >
          <SingleDatePicker
            id="end-date"
            label={t("label.date")}
            value={endDate}
            onChange={handleEndDateChange}
            minDate={startDate}
            maxDate={maxEndDate}
          />
        </FormField>
        <TimePicker
          id="end-time"
          label={t("label.time")}
          value={endTime}
          onChange={handleEndTimeChange}
          minTime={startTime}
        />
      </TwoColumnElementsContainer>
    </ElementsContainer>
  );
};
